export const mockCustomerCreditTransactions = [
  {
    id: 1,
    date: "2026-01-10",
    type: "deposit",
    description: "Uplata kredita",
    amount: 50.00,
    balance: 150.00,
  },
  {
    id: 2,
    date: "2026-01-09",
    type: "withdrawal",
    description: "Narudžbina - Piletina sa povrćem",
    amount: 8.50,
    balance: 100.00,
  },
  {
    id: 3,
    date: "2026-01-09",
    type: "withdrawal",
    description: "Narudžbina - Čorba i salata",
    amount: 5.50,
    balance: 108.50,
  },
  {
    id: 4,
    date: "2026-01-08",
    type: "withdrawal",
    description: "Narudžbina - Ćevapi sa lepinjom",
    amount: 7.00,
    balance: 114.00,
  },
  {
    id: 5,
    date: "2026-01-08",
    type: "deposit",
    description: "Uplata kredita",
    amount: 100.00,
    balance: 121.00,
  },
  {
    id: 6,
    date: "2026-01-05",
    type: "withdrawal",
    description: "Narudžbina - Riba sa rižom",
    amount: 12.00,
    balance: 21.00,
  },
  {
    id: 7,
    date: "2026-01-04",
    type: "withdrawal",
    description: "Narudžbina - Pasta carbonara",
    amount: 9.50,
    balance: 33.00,
  },
  {
    id: 8,
    date: "2026-01-03",
    type: "deposit",
    description: "Inicijalna uplata",
    amount: 42.50,
    balance: 42.50,
  },
];
